import { useEffectEvent, useLayoutEffect } from 'react'
import { parseAsBoolean, parseAsString, useQueryStates } from '@/libs/nuqs'
import { hydrateFromURL } from '../store'

const uiParams = {
	customerId: parseAsString,
	createCustomer: parseAsBoolean,
	viewMemberId: parseAsString,
	memberId: parseAsString,
	createMember: parseAsBoolean,
	q: parseAsString,
}

const useUI = () => {
	const [params] = useQueryStates(uiParams)

	const hydrate = useEffectEvent(() => {
		hydrateFromURL(params)
	})

	useLayoutEffect(() => {
		hydrate()
	}, [])

	return null
}

export { useUI }
